import { LoginAPI } from 'ducks/types/store-types';
import { v4 as uuidv4 } from 'uuid';

import { AUTHENTICATION_RESULTS } from './operators';

export function normalizeUser(user: LoginAPI) {
  if (user.authentication_result === AUTHENTICATION_RESULTS.SUCCESS) {
    localStorage.setItem('user', JSON.stringify(user));
  }

  return {
    ...user,
    error: '',
    uuid: uuidv4(),
  };
}

export const getQuery = () => {
  try {
    const query = localStorage.getItem('query');
    if (query === null || query === undefined) {
      return {};
    }
    return JSON.parse(query);
  } catch (err) {
    return {};
  }
};

export const setQuery = (query = {}) => {
  localStorage.setItem('query', JSON.stringify(query));
};
